const fileDownload = (content: string, filename: string, contentType: string) => {
    const navigator: any = window.navigator;

    // IE
    if (navigator && navigator.msSaveOrOpenBlob) {
        let byteCharacters = Buffer.from(content, "utf8").toString("base64");
        let byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);
        let blob = new Blob([byteArray], { type: contentType });

        navigator.msSaveOrOpenBlob(blob, filename);

        return;
    }

    // For Other Browsers
    const link = document.createElement("a");
    link.href = "data:" + contentType + ";base64," + content;
    link.download = filename;

    document.body.appendChild(link);

    link.click();
    link.remove();

    window.addEventListener(
        "focus",
        function () {
            URL.revokeObjectURL(link.href);
        },
        { once: true }
    );
};

export default fileDownload;
